import firebase from 'firebase'
import history from 'components/history'
import * as _ from 'lodash'
import generate from 'firebase-auto-ids'

import { getTemplateByApp, createDefaultCustomFields, getTemplateInfo } from 'templates/templates'
import { changeEditorScene } from 'actions/locationAC'
import { ref, storageRef, auth } from 'constants/firebase'
import { updateCustomStyle } from 'actions/appsAC'
import { displaySuccess, displayWarning } from 'components/NotificationController'
import { toAppName } from 'utils/utils'
import { setLastApp } from 'actions/lastAppAC'

export function createNewApp (appId, appName, templateId, customFields = {}) {
  return function * (dispatch, getState) {
    try {
      const state = getState()
      const id = appId
      const userId = state.authData.id
      let name = generate(_.now())
      if (_.isNil(appName)) {
        if (_.has(state.user, 'companyName')) {
          const nextAppNum = _.size(state.apps) + 1
          const companyName = toAppName(state.user.companyName)
          name = `${companyName}-${nextAppNum}`
        }
      } else {
        name = appName
      }
      const app = {
        id,
        name,
        templateId,
        createdAt: firebase.database.ServerValue.TIMESTAMP
      }
      const templateInfo = getTemplateInfo(templateId)
      console.log('templateInfo', templateInfo)
      if (templateInfo.defaultSlides) {
        console.log('defaultSlides', templateInfo.defaultSlides)
        const defaultCF = createDefaultCustomFields(templateId, templateInfo.defaultSlides)
        console.log('defaultCF', defaultCF)
        app.customFields = _.assign(customFields, defaultCF)
      } else {
        app.customFields = customFields
      }
      console.log(userId, 'create new app', app)
      yield ref.child('users').child(userId).child('apps').child(id).set(app)
      // console.log('push to /app', appId)
      history.push(`/app/${appId}`)
      dispatch(deleteTemporaryIntegrationData())
    } catch (e) {
      console.error('creating app error', e)
    }
  }
}

export function checkFieldIsDone (field, app) {
  for (const path of field.paths) {
    // console.log('check path', field.paths, 'app', app.customFields)
    if (_.has(app.customFields, path)) {
      // console.log(path, 'true')
    } else {
      // console.log(path, 'false')
      return false
    }
  }
  return true
}

export function setCustomFieldArray (appId, pathArray, value) {
  return function * (dispatch, getState) {
    let path = '' // path array => path string
    for (let i = 0; i < pathArray.length; i++) {
      path += pathArray[i] + (i === pathArray.length - 1 ? '' : '/')
    }

    dispatch(setCustomField(appId, path, value))
  }
}

export function setCustomField (appId, path, value) {
  return function * (dispatch, getState) {
    const userId = getState().authData.id
    // console.log('setCustomField path', path, 'value', value, 'userId', userId, 'appId', appId)
    try {
      yield ref.child('users').child(userId).child('apps').child(appId).child('customFields').child(path).set(value)
    } catch (e) {
      console.warn('can`t update customField, userId', userId, 'appId', appId, 'path', path, 'value', value, 'error', e)
    }
  }
}

export function applyCustomFields (customFields, settings) {
  // console.log('applyCustomFields customFields', customFields)
  // console.log('applyCustomFields settings', settings)
  if (_.get(settings, ['appSettings', 'overrideArrays'], false)) {
    return _.mergeWith(_.cloneDeep(settings), customFields, (objValue, srcValue) => {
      if (_.isArray(objValue) && _.isArray(srcValue)) {
        return srcValue
      }
    })
  } else {
    return _.mergeWith(_.cloneDeep(settings), customFields)
  }
}

export function publish (app, notificationNeeded = true, publicName = null) {
  return function * (dispatch, getState) {
    console.log('publish app')
    if (auth.currentUser.isAnonymous) {
      displayWarning('Sign in or sign up to continue')
      dispatch(setLastApp(app.id))
      history.push('/auth')
    } else {
      const state = getState()
      const authData = state.authData
      const pName = publicName || app.name
      const currentPublishedUserIdSN = yield ref.child('public').child(pName).child('userId').once('value')
      const currentPublishedUserId = currentPublishedUserIdSN.val()
      if (currentPublishedUserId === null || currentPublishedUserId === authData.id || pName === 'splash-test-store') {
        console.log('pName', pName)
        const template = getTemplateByApp(app)
        const settings = applyCustomFields(app.customFields, template.settings)
        settings.templateId = app.templateId
        settings.userId = authData.id
        settings.appId = app.id
        settings['appUninstalled'] = false

        yield ref.child('public').child(pName).set(settings)
        yield ref.child('users').child(authData.id).child('apps').child(app.id).child('published').set(firebase.database.ServerValue.TIMESTAMP)

        if (notificationNeeded) displaySuccess(`App is published: https://whimms.com/${pName}`)
      } else {
        console.log('The app URL is already exist. Please change the URL in the app settings')
        if (notificationNeeded) displayWarning('The app URL is already exist. Please change the URL in the app settings')
      }
    }
  }
}

export function updateNumberOfSlidesSimple (appId, slidesCnt) {
  return function * (dispatch, getState) {
    const userId = getState().authData.id
    yield ref.child('users').child(userId).child('apps').child(appId).child('slidesCnt').set(slidesCnt)
  }
}

export function setNumberOfSlides (app, slidesCnt) {
  return function * (dispatch, getState) {
    const state = getState()
    const userId = state.authData.id
    if (_.has(app, 'slidesCnt') && app.slidesCnt > slidesCnt) {
      dispatch(changeEditorScene(0))
    }
    const template = getTemplateByApp(app)
    const paths = template.createDeleteSlidePath(app, slidesCnt)
    // console.log('setNumberOfSlides, paths', paths)
    for (const path of paths) {
      ref.child('users').child(userId).child('apps').child(app.id).child('customFields').child(path).set(null)
    }
    yield ref.child('users').child(userId).child('apps').child(app.id).child('slidesCnt').set(slidesCnt)
  }
}

export function addSlide (app) {
  return function * (dispatch, getState) {
    const state = getState()
    const userId = state.authData.id
    const template = getTemplateByApp(app)
    if (template.addSlide) template.addSlide(app)
    const appUpdateData = {
      slidesCnt: app.slidesCnt + 1,
      customFields: app.customFields
    }
    yield ref.child('users').child(userId).child('apps').child(app.id).update(appUpdateData)
  }
}

export function delSlide (app, slideNum) {
  return function * (dispatch, getState) {
    // console.log('del slide', slideNum)
    const state = getState()
    const userId = state.authData.id
    const template = getTemplateByApp(app)
    if (template.delSlide) template.delSlide(app, slideNum)
    const appUpdateData = {
      slidesCnt: app.slidesCnt - 1,
      customFields: app.customFields
    }
    yield ref.child('users').child(userId).child('apps').child(app.id).update(appUpdateData)
  }
}

export function saveCssFile (app, fileContent, storageChildName, urlChildName) {
  return function * (dispatch, getState) {
    // console.log('uploadToStorage', file)
    const state = getState()
    const userId = state.authData.id

    try {
      const cssFileRef = storageRef.child('users').child(userId).child(app.id).child(storageChildName)
      const format = firebase.storage.StringFormat.RAW
      const metadata = {
        contentType: 'text/css'
      }
      const snapshot = yield cssFileRef.putString(fileContent, format, metadata)
      const downloadURL = snapshot.downloadURL
      ref.child('users').child(userId).child('apps').child(app.id).child('customFields').child(urlChildName).set(`${downloadURL}&${_.now()}`)
    } catch (e) {
      console.error('upoading custom css file error', e)
    }
  }
}

export function updateCustomCssRawFile (app, key, value) {
  return function * (dispatch, getState) {
    const state = getState()
    const userId = state.authData.id
    let stylesRaw = _.clone(app.customStylesRaw)
    // console.log('stylesRaw', stylesRaw, 'value', value)
    if (!stylesRaw) stylesRaw = {}
    stylesRaw[key] = value
    ref.child('users').child(userId).child('apps').child(app.id).child('customStylesRaw').child(key).set(value)
    // console.log('stylesRaw', stylesRaw)
    const fileContent = _.join(_.values(stylesRaw), '\n')
    // console.log('fileContent', fileContent)
    dispatch(saveCssFile(app, fileContent, 'stylesRaw', 'customStylesRawDownloadUrl'))
  }
}

export function updateCustomStyleEffectLocally (app, className, effectName, value) {
  return function * (dispatch, getState) {
    const effects = _.get(app, [ 'customFields', 'customStyles', className ], {})
    const effectsCopy = _.clone(effects)
    if (_.isEmpty(value)) {
      _.unset(effectsCopy, effectName)
    } else {
      effectsCopy[effectName] = value
    }
    dispatch(updateCustomStyle(app.id, className, effectsCopy))
  }
}

export function updateCustomStyleEffect (app, className, effectName, value) {
  return function * (dispatch, getState) {
    const state = getState()
    const userId = state.authData.id
    const effects = _.get(app, [ 'customFields', 'customStyles', className ], {})
    const effectsCopy = _.clone(effects)
    if (_.isEmpty(value)) {
      _.unset(effectsCopy, effectName)
    } else {
      effectsCopy[effectName] = value
    }
    dispatch(updateCustomStyle(app.id, className, effectsCopy))
    ref.child('users').child(userId).child('apps').child(app.id).child('customFields').child('customStyles').child(className).set(effectsCopy)
  }
}
// `updates` = { stylePrestType.POSITION: newPositionValue, stylePrestType.ZOOM: newZoomValue, ... }
export function updateCustomStyleEffects (app, className, updates) {
  return function * (dispatch, getState) {
    const state = getState()
    const userId = state.authData.id
    const effects = _.get(app, [ 'customFields', 'customStyles', className ], {})
    const effectsCopy = _.clone(effects)

    for (let [effectName, value] of Object.entries(updates)) {
      if (_.isEmpty(value)) {
        _.unset(effectsCopy, effectName)
      } else {
        effectsCopy[effectName] = value
      }
    }

    dispatch(updateCustomStyle(app.id, className, effectsCopy))
    ref.child('users').child(userId).child('apps').child(app.id).child('customFields').child('customStyles').child(className).set(effectsCopy)
  }
}

export async function isAppNameUnique (appName) {
  if (appName && appName !== '') {
    const existingPublishedSN = await ref.child('public').child(appName).once('value')
    const existingPublished = existingPublishedSN.val()
    if (existingPublished === null) {
      return true
    } else if (existingPublished.userId === auth.currentUser.uid) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export function deleteTemporaryIntegrationData () {
  return function * (dispatch, getState) {
    const state = getState()
    const userId = state.authData.id
    ref.child('users').child(userId).child('temporaryIntegrationData').set(null)
  }
}

export function changeAppName (app, newName) {
  return function * (dispatch, getState) {
    const state = getState()
    const userId = state.authData.id
    const publishedSN = yield ref.child('public').child(app.name).once('value')
    const publishedData = publishedSN.val()
    if (publishedData) {
      ref.child('public').child(newName).set(publishedData)
      ref.child('public').child(app.name).set(null)
    }
    ref.child('users').child(userId).child('apps').child(app.id).child('name').set(newName)
  }
}

export function getCustomStyleClassName (app, field, className) {
  // console.log('getCustomStyleClassName', app.id, field, className)
  let res = ''
  if (_.isFunction(className)) {
    const slideId = _.get(app.customFields, field.slideIdPath, field.num)
    // console.log('slideId not found, path', field.slideIdPath, 'customFields', app.customFields)
    // console.log('slideId', slideId)
    res = className(slideId)
  } else if (_.isString(className)) {
    res = className
  } else {
    console.warn('incorrect className', className)
  }
  // console.log('getCustomStyleClassName res', className, res)
  return res
}



// WEBPACK FOOTER //
// ./src/controllers/logic.js